// extracted by mini-css-extract-plugin
export default {"body":"products_body__lN-Hg","strong":"products_strong__86inO"};